(function () {
  function init() {
    var toc = document.getElementById('article-toc');
    var content = document.querySelector('.main-article__content');
    if (!toc || !content) return;

    var headings = content.querySelectorAll('h2');
    if (headings.length < 2) {
      toc.style.display = 'none';
      return;
    }

    // Build TOC HTML
    var html = '<p class="article-toc-title">Table of Contents</p><ul class="article-toc-list">';
    headings.forEach(function (h2, i) {
      var text = h2.textContent.trim();
      var slug = 'toc-' + i + '-' + text
        .toLowerCase()
        .replace(/<[^>]*>/g, '')
        .replace(/[^\w\u4e00-\u9fff]+/g, '-')
        .replace(/^-|-$/g, '');
      h2.id = slug;
      html += '<li><a href="#' + slug + '">' + text + '</a></li>';
    });
    html += '</ul>';
    toc.innerHTML = html;
    toc.classList.add('is-visible');

    // Click → smooth scroll with header offset
    var links = toc.querySelectorAll('a');
    links.forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(this.getAttribute('href').substring(1));
        if (target) {
          var offset = 100;
          var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
        // Mobile: close list after click
        if (window.innerWidth <= 767) {
          toc.classList.remove('is-open');
        }
      });
    });

    // Mobile toggle
    if (window.innerWidth <= 767) {
      var title = toc.querySelector('.article-toc-title');
      title.classList.add('article-toc-toggle');
      title.addEventListener('click', function () {
        toc.classList.toggle('is-open');
      });
    }

    // Scroll highlight with IntersectionObserver
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var link = toc.querySelector('a[href="#' + entry.target.id + '"]');
          if (!link) return;
          if (entry.isIntersecting) {
            links.forEach(function (l) { l.classList.remove('toc-active'); });
            link.classList.add('toc-active');
          }
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    headings.forEach(function (h2) { observer.observe(h2); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
